module.exports = __webpack_public_path__ + "static/media/PLUImage.9435600e.jpeg";